import React, {useState, useEffect, useCallback} from 'react'
import './../../App.css';
import './Reports.css';
import axios from 'axios';
import { CreateSearchBarWithPlaceHolder } from '../CommonObjects';
import {CreateTableForEmployeeSelect} from '../ManageTable';
import {token, domain} from '../Security';
import loadingSpinner from './../../assets/loading.gif';
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
//icons
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function CertificateOfSSS({user, isHideSideMenu}) {
    const [employeePersonalInformationId, setEmployeePersonalInformationId] = useState("");
    const [employeePersonalInformationFullName, setEmployeePersonalInformationFullName] = useState("");
    const [year, setYear] = useState("");
    const [showEmployeeForm, setShowEmployeeForm] = useState(false);
    const [errorState, setErrorState] = useState(false);
    const [companyId, setCompanyId] = useState(0);
    const [company, setCompany] = useState(null);
    const [loading, setLoading] = useState(false);
    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const closeEmployeeForm = () => {
        setShowEmployeeForm(false);
    }

    const numberWithCommasAndDecimal = (number) => {
        if(!number){
            return "0.00";
        }
        return number.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    const writeFont8Black = ({page, font, x, y, text}) => {
        page.drawText(text, {
            x: x,  // Adjust X position
            y: y,  // Adjust Y position
            size: 8, 
            font: font,
            color: rgb(0, 0, 0), // Black text
        })
    }
    const writeFont9Black = ({page, font, x, y, text}) => {
        page.drawText(text, {
            x: x,  // Adjust X position
            y: y,  // Adjust Y position
            size: 9, 
            font: font,
            color: rgb(0, 0, 0), // Black text
        })
    }
    const writeFont11Black = ({ page, font, x, y, text, maxWidth }) => {
        const words = text.split(" ");
        let line = "";
        let lineHeight = 20; // Adjust line spacing if needed
        let yPosition = y;
    
        for (let i = 0; i < words.length; i++) {
            let testLine = line + words[i] + " ";
            let textWidth = font.widthOfTextAtSize(testLine, 11); // Measure text width
    
            if (textWidth > maxWidth && line !== "") {
                // Draw the line when maxWidth is exceeded
                page.drawText(line, { x, y: yPosition, size: 11, font, color: rgb(0, 0, 0) });
                yPosition -= lineHeight; // Move to the next line
                line = words[i] + " ";
            } else {
                line = testLine;
            }
        }
    
        // Draw the last remaining line
        page.drawText(line, { x, y: yPosition, size: 10, font, color: rgb(0, 0, 0) });
    };

    const modifyAndDownloadPDF = useCallback(async (data) => {
        if (data.length <= 0) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            setRequestMessage("No records found");
            return;
        }

        setLoading(true);
        console.log(data)

        try {
            // Load the existing PDF template
            const pdfUrl = `${window.location.origin}/docs/CERTIFICATE_OF_SSS.pdf`;
            const response = await fetch(pdfUrl);
            const pdfBytes = await response.arrayBuffer();
            const pdfDoc = await PDFDocument.load(pdfBytes);

            let page = pdfDoc.getPages()[0]; // Get first page
            const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

            //611 height

            const _dateToday = new Date().toISOString().split("T")[0];

            writeFont11Black({ page, font, x: 40, y: 487, maxWidth: 700, text: `This is to certify that ${company.name} has remitted the following SSS contributions for ${employeePersonalInformationFullName} with SSS No. ${data[0].sssNo ? data[0].sssNo : "-undefined in accont information-"} as of follows:` });

            const startX_item_1 = 40;
            const startX_item_2 = 180;
            const startX_item_3 = 395;
            const startX_item_4 = 540;
            const startX_item_5 = 685;
            let startY = 390;
            const lineSpacing = 15;

            let totalER = 0;
            let totalEE = 0;
            let totalTotal = 0;

            for (let index = 0; index < data.length; index++) {
                const item = data[index];
            
                // Write employee data
                writeFont8Black({ page, font, x: startX_item_1, y: startY, text: `${item.payrollPeriodDescription}` });
                writeFont8Black({ page, font, x: startX_item_2, y: startY, text: `${item.remittedDate ? item.remittedDate : "not defined"}` });
                writeFont8Black({ page, font, x: startX_item_3, y: startY, text: `${numberWithCommasAndDecimal(item.employerShare)}` });
                writeFont8Black({ page, font, x: startX_item_4, y: startY, text: `${numberWithCommasAndDecimal(item.employeeShare)}` });
                writeFont8Black({ page, font, x: startX_item_5, y: startY, text: `${numberWithCommasAndDecimal(item.total)}` });

                totalER += item.employerShare;
                totalEE += item.employeeShare;
                totalTotal += item.total;
            
                startY -= lineSpacing; // Move to next row
            }
            
            writeFont9Black({ page, font, x: startX_item_3, y: 150, text: `${numberWithCommasAndDecimal(totalER)}` });
            writeFont9Black({ page, font, x: startX_item_4, y: 150, text: `${numberWithCommasAndDecimal(totalEE)}` });
            writeFont9Black({ page, font, x: startX_item_5, y: 150, text: `${numberWithCommasAndDecimal(totalTotal)}` });

            writeFont11Black({ page, font, x: 40, y: 105, maxWidth: 700, text: `Issued on ${_dateToday} by ${user.employeePersonalInformationFullName}` });

            setShowRequestMessage(true);
            setIsSuccess(true);

            // Save and Download PDF
            const modifiedPdfBytes = await pdfDoc.save();
            const blob = new Blob([modifiedPdfBytes], { type: "application/pdf" });

            const a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = `CERTIFICATE_OF_SSS.pdf`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(a.href);
        } catch (error) {
            setShowRequestMessage(true);
            setIsSuccess(false);
            console.error("Error:", error);
            setRequestMessage("Error processing PDF");
        }

        setLoading(false);
    }, [company, employeePersonalInformationFullName, user]);

    const fetchDataCompany = useCallback(async () => {
        const apiUrl =  domain + `/api/Company/${companyId}`;

        try {
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})
            
            return response.data;
        } catch (error) {
            return null
        }
    }, [companyId]);

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + `/api/Reports/certificate-of-sss/employee/${employeePersonalInformationId}/year/${year}`;

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json' // You can include other headers if needed
            }})

            const _company = await fetchDataCompany();
            setCompany(_company)

            modifyAndDownloadPDF(response.data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }, [modifyAndDownloadPDF, fetchDataCompany, employeePersonalInformationId, year]);

    const generate = () =>{
        if(!employeePersonalInformationId || !year || !companyId){
            setErrorState(true);
            return;
        }
        setErrorState(false);
        fetchData();
    };

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="ReportsInfo">
                        <div className="reports-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Reports >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Certificate Of SSS"}</span>
                            </div>
                            <h3>Generate Certificate Of SSS</h3>
                        </div>
                        <div className="reports-body">
                            <div className="info-item-holder row" style={{justifyContent: "normal", alignItems: "center"}}>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Employee</div>
                                    <div className="info-item-input">
                                        <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                            <input
                                                readOnly
                                                className='employeeInput-select'
                                                placeholder="Employee"
                                                value={employeePersonalInformationId ? (employeePersonalInformationFullName) : employeePersonalInformationId}
                                            />
                                            <button className="select row"
                                                    onClick={()=>setShowEmployeeForm(true)}
                                            ><SearchIcon/></button>
                                        </div>
                                        <span style={{
                                                visibility: !employeePersonalInformationId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                        </span>
                                        {/* {EmployeeIdSelect(employeePersonalInformationId, setEmployeePersonalInformationId)} */}
                                    </div>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Year</div>
                                    <div className="info-item-input">
                                        <Year year={year} setYear={setYear}/>
                                    </div>
                                    <span style={{
                                                visibility: !year && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                                <div className="info-item3 info-item column">
                                    <div className="info-item-label" style={{fontWeight:"normal", fontSize:"14px"}}>Company</div>
                                    <div className="info-item-input">
                                        <CompanyTypeSelect companyId={companyId} setCompanyId={setCompanyId} setCompany={setCompany}/>
                                    </div>
                                    <span style={{
                                                visibility: !companyId && errorState ? "visible" : "hidden",
                                                color:"#ff6565", 
                                                fontSize:"12px"}}>Please fill up this field
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="reports-footer">
                            <div className="buttons row">
                                <button id="resignedGenerate"
                                    className="generate row" 
                                    onClick={generate}
                                    > GENERATE
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <EmployeeSelectForm  isOpen={showEmployeeForm} 
                    onClose={closeEmployeeForm}
                    setEmployeeId={setEmployeePersonalInformationId}
                    setEmployee={setEmployeePersonalInformationFullName}
            >
            </EmployeeSelectForm>
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loading? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function EmployeeSelectForm({isOpen, 
    onClose,
    setEmployeeId,
    setEmployee,
}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        setEmployeeId(selectedEmployee.id);
        setEmployee(selectedEmployee.fullName);
        fetchData();
    };

    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterData, setFilterData] = useState([]);
    const [filterDataIndex, setFilterDataIndex] = useState(0);
    const [searchPlaceholder, setSearchPlaceholder] = useState("Search by name");

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Employee/";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setEmployees(response.data); // Set the response data to the state
                setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }
    const [currentPage, setCurrentPage] = useState(1);
    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = [];

        switch (filterDataIndex) {
            case 0:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                break;
            case 1:
                res = filterData.filter((f) =>
                f.employeeId.toString().startsWith(lowercaseValue)
                );
                break;
            default:
                res = filterData.filter((f) =>
                f.fullName.toLowerCase().includes(lowercaseValue)
                );
                
                break;
        }

        setEmployees(res);
    };

    useEffect(() => {
        switch (filterDataIndex) {
            case 0:
                setSearchPlaceholder("Search by name")
                break;
            case 1:
                setSearchPlaceholder("Search by id")
                break;
            default:
                setSearchPlaceholder("Search by name")
                break;
        }
        fetchData();
    }, [filterDataIndex]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <EmployeeFilter setFilterDataIndex={setFilterDataIndex}/>
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                searchPlaceholder,
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body">
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function EmployeeFilter({setFilterDataIndex}){
    const [selectedOption, setSelectedOption] = useState("All");

    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);

        switch (event.target.value) {
            case "All":
                setFilterDataIndex(0);
                break;
            case "EmployeeId":
                setFilterDataIndex(1);
                break;
            default:
                setFilterDataIndex(0);
                break;
        }
    };

    return (
        <div className="filters row" style={{alignItems:"center"}}>
            <span style={{marginRight:"10px"}}>Filter</span>
            <select id="" className="filterSelect" value={selectedOption} onChange={handleSelectChange}>
                <option value="All">All</option>
                <option value="EmployeeId">Employee Id</option>
            </select>
        </div>
    );
};
function Year({year, setYear}){
    const [isSelected, setIsSelected] = useState(false);
    
    const handleSelectChange = (event) => {
        setYear(event.target.value);
        setIsSelected(true);
    };

    // Generate years from 2019 to the current year
    const getCurrentYear = () => new Date().getFullYear();
    const startYear = 2019;
    const years = Array.from({ length: getCurrentYear() - startYear + 1 }, (_, index) => (startYear + index).toString()).reverse();;

    useEffect(() => {
        if(year !== "" && year !== 0){
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [year]);

    return (
        <div>
            <select id="yearSSSReport-select" value={year} onChange={handleSelectChange} style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose a year</option>
            {years.map((yearName, index) => (
                <option key={index} value={yearName}>{yearName}</option>
            ))}
            </select>
        </div>
    );
};
function CompanyTypeSelect({companyId, setCompanyId, setCompany}){
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const selectedCompanyId = event.target.value; // Get the selected company ID
        setCompanyId(selectedCompanyId);
        const selectedCompany = data.find((comp) => comp.id.toString() === selectedCompanyId.toString()); // Find the full company object

        if (selectedCompany) {
            setCompany(selectedCompany); // Set the full company object
        }
    };

    const [data, setData] = useState([]);

    const fetchData = async () => {
        const apiUrl =  domain + "/api/Company/active";

        await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
        .then(response => {
            response.data.sort((a, b) => a.name.localeCompare(b.name));
            setData(response.data); // Set the response data to the state
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    useEffect(() => {
        fetchData();
        if (companyId !== "" && companyId !== 0 && companyId !== null && companyId !== undefined && companyId.length !== 0) {
            setIsSelected(true);
        } else {
            setIsSelected(false);
        }
    }, [companyId]);

    return (
        <div>
            <select id="employee-select-PagibigReport" value={companyId || ""} onChange={handleSelectChange}style={{ color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)" }}>
            <option value="" disabled hidden>Choose company type</option>
            {data.map((companyId) => ( 
                SetCompanyType(companyId)
            ))}
            </select>
        </div>
    );
};
function SetCompanyType(companyId){
    return(
        <option value={companyId.id}>{
            companyId.name}
        </option>
    )

}

export default CertificateOfSSS
